import { defineStore } from "pinia";

// TODO: consolidate into the smart-feed store once the feed response carries
// the publication's filter options + items in one payload — the chip list is
// the same data the feed already returns. Today this stays a separate store
// so the chip fetch's `apiGet` doesn't toggle the smart-feed store's shared
// `isLoading` flag, which races the feed's initial fetch.
export const useCollectionCategoryStore = defineStore("collection-category-store", {
  state: () => ({
    categoryCollections: [],
    isLoadingCategoryCollections: false,
  }),
  actions: {
    fetchCategoryCollectionsForPublication(orgId, publicationId) {
      if (!orgId || !publicationId) {
        this.categoryCollections = [];
        return;
      }
      this.isLoadingCategoryCollections = true;
      this.apiGet(
        `/affiliate-link-collection/active/publication/${publicationId}`,
        { org_id: orgId },
        data => {
          this.categoryCollections = data.collections;
          this.isLoadingCategoryCollections = false;
        },
        () => {
          this.categoryCollections = [];
          this.isLoadingCategoryCollections = false;
        },
      );
    },
  },
});
